import { render, staticRenderFns } from "./ServicesEntity.vue?vue&type=template&id=0df8909a&"
import script from "./ServicesEntity.vue?vue&type=script&lang=js&"
export * from "./ServicesEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports